<template>
  <!--  专题首页-->
  <div class="topicIndex">
    <div class="topic_box">
      <el-card>
        <el-form :inline="true" label-width="120px" size="small">
          <el-row>
            <el-col :span="8">
              <el-form-item label="专题名字">
                <el-input
                  placeholder="请输入标题"
                  v-model="srarchDas.specialName"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="信息流展示">
                <el-select placeholder="请选择" v-model="srarchDas.showPosition" clearable>
                  <el-option
                    v-for="item in messDas"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>-->
            <el-col :span="8">
              <el-form-item label="是否首页轮播">
                <el-select
                  placeholder="请选择"
                  v-model="srarchDas.isHomeRotation"
                  clearable
                >
                  <el-option
                    v-for="item in homeLun"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- <el-form-item label="是否过审">
                <el-select placeholder="请选择" v-model="srarchDas.examineStatus" clearable>
                  <el-option
                    v-for="item in shenDas"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>  v-if="!publisherUser"-->
              <el-form-item label="状态">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="srarchDas.examineStatus"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in newsStatus"
                  ></el-option>
                </el-select>
              </el-form-item>

              <!-- <el-form-item label="状态" v-if="!reviewerUser">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="srarchDas.examineStatus"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in revernewsStatus"
                  ></el-option>
                </el-select>
              </el-form-item>-->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="频道">
                <el-select
                  placeholder="请选择"
                  v-model="srarchDas.menuId"
                  clearable
                >
                  <el-option
                    v-for="item in menuDas"
                    :key="item.id"
                    :label="item.menuName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否首页">
                <el-select
                  placeholder="请选择"
                  v-model="srarchDas.isRecommend"
                  clearable
                >
                  <el-option
                    v-for="item in homeIn"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否本频道轮播">
                <el-select
                  placeholder="请选择"
                  v-model="srarchDas.isRotation"
                  clearable
                >
                  <el-option
                    v-for="item in viewLun"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <el-button
              style="margin-left: 120px"
              type="primary"
              @click="topicSearch"
              v-if="menuPerm('special:query')"
              >查询</el-button
            >

            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="topicAdd"
              v-if="menuPerm('special:add')"
              >添加</el-button
            >
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="topicClear"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>

      <el-card>
        <el-table
          :data="topicList"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            prop="imgUrl"
            label="app专题封面图"
            width="200px"
            height="200px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="topic_img">
                <img :src="row.imgUrl" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="pcImgUrl"
            label="pc专题封面图"
            width="200px"
            height="200px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div class="topic_img">
                <img :src="row.pcImgUrl" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="specialName"
            label="专题名字"
            align="center"
            width="200"
          >
            <template slot-scope="{ row }">
              <a-tooltip>
                <template slot="title">{{ row.specialName }}</template>
                <span class="news_title">{{ row.specialName }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="specialExplain"
            label="专题说明"
            align="center"
            width="200px"
          >
            <template slot-scope="{ row }">
              <a-tooltip>
                <template slot="title">{{ row.specialExplain }}</template>
                <span class="news_title">{{ row.specialExplain }}</span>
              </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="权重" align="center" width="80px">
          </el-table-column>

          <el-table-column
            prop="examineStatus"
            label="审核状态"
            align="center"
            width="180px"
          >
            <template slot-scope="{ row }">
              <el-select
                placeholder="请选择"
                v-model="row.examineStatus"
                v-if="menuPerm('special:review')"
                @change="examChange($event, row)"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in newsStatus"
                ></el-option>
              </el-select>

              <div v-if="menuPerm('special:submit_review')">
                <span v-if="row.examineStatus == 2">未提交审核</span>
                <span v-if="row.examineStatus == 3">审核中</span>
                <span v-if="row.examineStatus == 4">审核未通过</span>
                <span v-if="row.examineStatus == 1">审核通过</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="menuId" label="频道" align="center">
            <template slot-scope="{ row }">
              <div v-for="(item, index) in menuDas" :key="index">
                <span v-if="item.id == row.menuId">{{ item.menuName }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="isRecommend" label="是否首页" align="center">
            <template slot-scope="{ row }">
              <div v-if="row.isRecommend == '1'">是</div>
              <div v-if="row.isRecommend == '0'">否</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="isRotation"
            label="本频道轮播"
            align="center"
            width="100px"
          >
            <template slot-scope="{ row }">
              <div v-if="row.isRotation == 1">是</div>
              <div v-if="row.isRotation == 0">否</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="isHomeRotation"
            label="首页轮播"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.isHomeRotation == 1">是</div>
              <div v-if="row.isHomeRotation == 0">否</div>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="180px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <div class="done">
                <el-button
                  size="mini"
                  type="primary"
                  @click="topicEdit(row)"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  v-if="menuPerm('special:edit')"
                  >修改</el-button
                >

                <el-button
                  @click="handleExamine(row)"
                  size="mini"
                  type="primary"
                  v-if="menuPerm('special:submit_review')"
                  :disabled="
                    (row.examineStatus == 1 || row.examineStatus == 3) &&
                    allOpen
                      ? true
                      : false
                  "
                  >提交审核</el-button
                >
                <el-button type="primary" @click="push(row)" size="mini"
                  >推送</el-button
                >
                <el-button
                  type="primary"
                  @click="topicDetailed(row.id, row)"
                  size="mini"
                  v-if="menuPerm('special:query')"
                  >详情</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          {{ $store.state.currt }}
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
      <!-- 详情页面 -->
      <a-drawer
        title="专题详情"
        :width="900"
        :visible="detailvisible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Detail :Detaildata="detailData" />
      </a-drawer>
      <!-- 修改页面 -->
      <a-drawer
        title="专题修改"
        :width="900"
        :visible="editvisible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Edit :Editdata="editData" />
      </a-drawer>
    </div>
  </div>
</template>
<script>
import Detail from "./detailed";
import Edit from "./edit";
export default {
  data() {
    return {
      detailvisible: false,
      editvisible: false,
      detailData: "",
      editData: "",
      allOpen: true,
      // 流程：
      //角色：
      reviewerUser: true, //审核者
      publisherUser: true, //发布者
      // ------------------------
      topicList: [], //专题的列表
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      menuDas: "", //频道的数据
      //查询的数据：
      srarchDas: {
        specialName: "", //专题名字
        // showPosition: "", //是否信息流展示
        examineStatus: "", //是否过审
        menuId: "", //频道 id
        isRecommend: "", //是否首页
        isRotation: "", //是否本频道轮播
        isHomeRotation: "", //是否首页轮播
      },
      //状态--下拉框：
      newsStatus: [
        {
          value: "2",
          label: "未提交审核",
        },
        {
          value: "3",
          label: "审核中",
        },
        {
          value: "4",
          label: "审核未通过",
        },
        {
          value: "1",
          label: "审核通过",
        },
      ],

      //   信息流展示：--下拉框
      messDas: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
      //是否过审--下拉框
      shenDas: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],

      //   是否上首页：--下拉框
      homeIn: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],

      //当前频道轮播:--下拉框
      viewLun: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
      //首页轮播--下拉框：
      homeLun: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
    };
  },
  components: {
    Detail,
    Edit,
  },
  methods: {
    onClose() {
      this.detailvisible = false;
      this.editvisible = false;
    },
    //修改专题的审核状态
    examChange(val, row) {
      console.log(val, "val", row.id, "row");
      this.getAxios("/special/review", {
        id: row.id,
        examineStatus: val,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("修改审核状态成功");
          this.getTopic();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //专题列表：
    getTopic() {
      this.postAxios("/special/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        specialName: this.srarchDas.specialName, //专题名字
        // showPosition: this.srarchDas.showPosition, //是否信息流展示
        examineStatus: this.srarchDas.examineStatus, //是否过审
        menuId: this.srarchDas.menuId, //频道 id
        isRecommend: this.srarchDas.isRecommend, //是否首页
        isRotation: this.srarchDas.isRotation, // 是否本频道轮播
        isHomeRotation: this.srarchDas.isHomeRotation, // 是否首页轮播
      }).then((res) => {
        if (res.success == true) {
          this.topicList = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
    //清空查询条件：
    topicClear() {
      (this.srarchDas.specialName = ""), //专题名字
        // this.srarchDas.showPosition = '', //是否信息流展示
        (this.srarchDas.examineStatus = ""), //是否过审
        (this.srarchDas.menuId = ""), //频道 id
        (this.srarchDas.isRecommend = ""), //是否首页
        (this.srarchDas.isRotation = ""), // 是否本频道轮播
        (this.srarchDas.isHomeRotation = ""); // 是否首页轮播
    },
    //新增专题：
    topicAdd() {
      this.$router.push({ path: "/topicAdd" }); //添加页面
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getTopic();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getTopic();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // app推送
    push(row) {
      this.getAxios("/app/push", {
        type: 6,
        id: row.id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.success == false && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //发布者- 提交审核：
    handleExamine(row) {
      this.getAxios("/special/submit/review", {
        id: row.id,
        // examineStatus:row.examineStatus
      }).then((res) => {
        if (res.success == true) {
          this.$message.success("提交审核成功");
          this.getTopic();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },

    //专题查询：
    topicSearch() {
      this.currentPage = 1;

      this.postAxios("/special/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        specialName: this.srarchDas.specialName, //专题名字
        // showPosition: this.srarchDas.showPosition, //是否信息流展示
        examineStatus: this.srarchDas.examineStatus, //是否过审
        menuId: this.srarchDas.menuId, //频道 id
        isRecommend: this.srarchDas.isRecommend, //是否首页
        isRotation: this.srarchDas.isRotation, // 是否本频道轮播
        isHomeRotation: this.srarchDas.isHomeRotation, // 是否首页轮播
      }).then((res) => {
        if (res.success == true) {
          this.topicList = res.content;
          this.totalCount = res.totalCount;
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.statusCode == "401" && res.success == false) {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },

    //跳转详情：
    topicDetailed(id, row) {
      this.detailvisible = true;
      this.detailData = row;
    },
    //专题修改：
    topicEdit(obj) {
      (this.editvisible = true), (this.editData = obj);
    },

    //频道下拉框数据：
    getPosition() {
      this.getAxios("/menu/list").then((res) => {
        if (res.success == true) {
          this.menuDas = res.content;
        }

        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
  },

  created() {
    this.getPosition(); //频道的数据
    this.getTopic(); //获取专题的列表

    if (this.menuPerm("special:edit_super") == true) {
      this.allOpen = false;
    }
  },
  mounted() {},
};
</script>
<style scoped lang="less">
.topicIndex {
  width: 100%;
  height: 100%;
  .topic_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .news_title {
        display: block;
        width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .topic_img {
        width: 200px;
        height: 150px;
        margin-left: -10px;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }
      /deep/ .el-table-column {
        text-align: center;
      }
    }
    .done {
      display: flex;
      flex-direction: column;
      width: 100px;

      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
        margin-top: 10px;
        margin-left: 10px;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>